export var connectorLocalStorageKey = "connectorIdv2";
export var walletLocalStorageKey = "wallet";
